var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZ(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 49.998c0 27.615-22.384 50.002-50 50.002-27.613 0-50-22.387-50-50.002 0-27.613 22.387-49.998 50-49.998 27.616 0 50 22.385 50 49.998z",
    id: "Shape",
    fill: "#C9C4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.355 79.999h-53.76v-2.711l42.635-57.22h-18.979c-3.118.063-5.517.391-7.2.981-1.683.594-3.242 1.73-4.675 3.413-.125.126-.233.25-.327.374-.093.126-.203.25-.327.373-.25.375-.483.702-.702.982-.219.28-.42.577-.607.889-.063.188-.156.374-.28.561l-.374.562c-.126.374-.281.765-.467 1.168-.188.406-.407.889-.654 1.449l-3.367-.094v-14.491h51.049v2.524l-43.007 57.406h18.605c2.805.063 5.033 0 6.685-.188 1.65-.187 3.193-.59 4.628-1.213l.514-.188.421-.188c.873-.436 1.714-.935 2.524-1.496.809-.561 1.62-1.215 2.431-1.963.561-.562 1.122-1.168 1.683-1.822.561-.655 1.153-1.388 1.777-2.197l2.431-3.461h3.552l-4.209 16.55z",
    fill: "#0D0F0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZ);
export default __webpack_public_path__ + "static/media/Z.e6cddc6878664ec9ccc027f722319fca.svg";
export { ForwardRef as ReactComponent };